var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["TouchBackend"]: () => __WEBPACK_EXTERNAL_MODULE_react_dnd_touch_backend_37f365f6__.TouchBackend });